import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus, AlertCircle, Target } from 'lucide-react';
import { Card } from '../ui/Card';
interface MetricTileProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  trend?: number; // percentage change
  alert?: 'warning' | 'danger';
  onClick?: () => void;
  subtext?: string;
  target?: number; // Monthly target
}
export function MetricTile({
  title,
  value,
  icon,
  trend,
  alert,
  onClick,
  subtext,
  target
}: MetricTileProps) {
  const getAlertStyles = () => {
    if (alert === 'danger') return 'border-l-4 border-l-red-500';
    if (alert === 'warning') return 'border-l-4 border-l-amber-500';
    return 'border-l-4 border-l-transparent';
  };
  const getTrendColor = (val: number) => {
    if (val > 0) return 'text-green-600';
    if (val < 0) return 'text-red-600';
    return 'text-gray-500';
  };
  // Calculate progress towards target
  const numericValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
  const progress = target ? Math.min(numericValue / target * 100, 100) : null;
  const isOnTrack = target ? numericValue >= target * 0.8 : true; // 80% of target = on track
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-5 cursor-pointer transition-all hover:shadow-md hover:scale-[1.02] ${getAlertStyles()}`} onClick={onClick} data-id="element-121">
      <div className="flex justify-between items-start mb-4" data-id="element-122">
        <div className="p-2 bg-blue-50 rounded-lg text-blue-700" data-id="element-123">{icon}</div>
        {alert && <AlertCircle className={`h-5 w-5 ${alert === 'danger' ? 'text-red-500' : 'text-amber-500'}`} data-id="element-124" />}
      </div>

      <div className="space-y-2" data-id="element-125">
        <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-126">
          {title}
        </h3>
        <div className="flex items-baseline gap-2" data-id="element-127">
          <span className="text-3xl font-bold text-gray-900" data-id="element-128">{value}</span>
          {trend !== undefined && <span className={`flex items-center text-xs font-medium ${getTrendColor(trend)}`} data-id="element-129">
              {trend > 0 ? <ArrowUpRight className="h-3 w-3 mr-0.5" data-id="element-130" /> : trend < 0 ? <ArrowDownRight className="h-3 w-3 mr-0.5" data-id="element-131" /> : <Minus className="h-3 w-3 mr-0.5" data-id="element-132" />}
              {Math.abs(trend)}%
            </span>}
        </div>

        {target && <div className="mt-3 space-y-1" data-id="element-133">
            <div className="flex items-center justify-between text-xs" data-id="element-134">
              <div className="flex items-center gap-1 text-gray-500" data-id="element-135">
                <Target className="h-3 w-3" data-id="element-136" />
                <span data-id="element-137">Target: {target.toLocaleString()}</span>
              </div>
              <span className={`font-medium ${isOnTrack ? 'text-green-600' : 'text-amber-600'}`} data-id="element-138">
                {progress?.toFixed(0)}%
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-139">
              <div className={`h-1.5 rounded-full transition-all ${isOnTrack ? 'bg-green-500' : 'bg-amber-500'}`} style={{
            width: `${progress}%`
          }} data-id="element-140"></div>
            </div>
          </div>}

        {subtext && <p className="text-xs text-gray-400 mt-1" data-id="element-141">{subtext}</p>}
      </div>
    </div>;
}